import { axiosClientAdmin } from '@/lib/auth';
import {
  TenantMonitoringCompanyCrudded,
  TenantMonitoringCompanyDto,
  TenantMonitoringCompaniesSearched,
} from './types';

import { Filter, FilterGroup, FilterOperator, SortOrder } from '@/lib/utils';

/**
 * Fetches a single monitoring company by tenant and company ID
 */
export async function getFetchCompanyTenantMonitoring(
  tenantId: string,
  companyId: string
): Promise<TenantMonitoringCompanyDto> {
  try {
    const response = await axiosClientAdmin.get<TenantMonitoringCompanyCrudded>(
      `/tenants/${tenantId}/TenantMonitoring/companies/${companyId}`
    );

    if (response.data.success) {
      return response.data.monitoringCompany || {};
    } else {
      console.error('Error fetching company tenant monitoring:', response.data.message);
      throw new Error(response.data.message || 'Failed to fetch monitoring company');
    }
  } catch (error) {
    console.error('Error fetching company tenant monitoring:', error);
    throw error;
  }
}

/**
 * Updates an existing monitoring company
 */
export async function updateCompanyTenantMonitoring(params: {
  tenantId: string;
  companyId: string;
  body?: TenantMonitoringCompanyDto;
}): Promise<TenantMonitoringCompanyCrudded> {
  try {
    const { tenantId, companyId, body } = params;
    const response = await axiosClientAdmin.post<TenantMonitoringCompanyCrudded>(
      `/tenants/${tenantId}/TenantMonitoring/companies/${companyId}`,
      body
    );

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to update monitoring company');
    }

    return response.data;
  } catch (error) {
    console.error('Error updating monitoring company:', error);
    throw error;
  }
}

/**
 * Creates a new monitoring company
 */
export async function createCompanyTenantMonitoring(params: {
  tenantId: string;
  body?: TenantMonitoringCompanyDto;
}): Promise<TenantMonitoringCompanyCrudded> {
  try {
    const { tenantId, body } = params;
    const response = await axiosClientAdmin.post<TenantMonitoringCompanyCrudded>(
      `/tenants/${tenantId}/TenantMonitoring/companies`,
      body
    );

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to create monitoring company');
    }

    return response.data;
  } catch (error) {
    console.error('Error creating monitoring company:', error);
    throw error;
  }
}

/**
 * Searches for monitoring companies with pagination and filtering
 * 
 * @deprecated
 */
export async function searchTenantMonitoringCompanies(params: {
  tenantId: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDir?: SortOrder;
  filterOperator?: FilterOperator;
  filterFilters?: Filter[];
  filterFilterGroups?: FilterGroup[];
}): Promise<TenantMonitoringCompaniesSearched> {
  try {
    const { tenantId, ...queryParams } = params;
    const response = await axiosClientAdmin.get<TenantMonitoringCompaniesSearched>(
      `/tenants/${tenantId}/TenantMonitoring/companies/search`,
      { params: queryParams }
    );

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to search monitoring companies');
    }

    return response.data;
  } catch (error) {
    console.error('Error searching monitoring companies:', error);
    throw error;
  }
}
